import { Select, MenuItem, InputLabel, Box, FormControl } from "@mui/material";
import { menuProps } from "../constants";

export const SelectNavigation = ({options, label, key }) => {
	const handleChange = (event) => {
		window.location.href = event.target.value;
	};
	return (
		<Box sx={{ 
			minWidth: { sm: '130px' }, 
			width: { xs: '100%', sm: 'auto' } }}>
			<FormControl fullWidth size="small">
				<InputLabel id={`${key}-select-label`}>{label}</InputLabel>
				<Select
					labelId={`${key}--select-label`}
					id={`${key}--select`}
					label={label}
					onChange={handleChange}
					value={options.find(option => option.current)?.permalink || ""}
					MenuProps={menuProps}
				>
					{ options.map((option, index) => (
						<MenuItem key={`${key}-${index}`} value={option.permalink}>{ option.title }</MenuItem>
					)) }
				</Select>
			</FormControl>
		</Box>
	);
}
